<div class="card">
  <div class="card-header" style="border-bottom: none">
    <div
      class="card-title d-flex flex-row justify-content-between align-items-center"
    >
      <h4 *ngIf="data.showYear">{{quarterYear}}</h4>
      <h4 style="margin: 0">{{ data.title }}</h4>
      <mat-icon
        *ngIf="data.download"
        style="cursor: pointer"
        matTooltip="Download scores"
        (click)="download()"
        >download</mat-icon
      >
      <div *ngIf="!data.download"></div>
    </div>
  </div>
  <div
    class="card-body"
    *ngIf="!generating"
  >
    <div *ngIf="editable" class="year"><strong>Q3 2025</strong></div>
    <div
      echarts
      [options]="chartOption"
      (chartInit)="onChartInit($event)"
      class="echart"
      [style.height]="data.chartHeight ? data.chartHeight : '65vh'"
    ></div>
    <div class="custom-legend">
      <div
        *ngFor="let item of config?.bubbleBorder | keyvalue"
        class="legend-item"
      >
        <div class="color-circle" [style.background-color]="item.value"></div>
        <span *ngIf="item.key == 'exceeds'"
          >Exceeds Expectations/Meets Expectations</span
        >
        <!-- <span *ngIf="item.key == 'expected'"></span> -->
        <span *ngIf="item.key == 'under'">Underperforming</span>
      </div>
    </div>
    <div class="chart-note" *ngIf="data.note1 || data.note2 || data.note3">
      <strong>Notes:</strong>
      <ul style="margin: 4px 0 0 16px; padding: 0">
        <li *ngIf="data.note1">
          Only the engine models that are sold in this quarter are displayed.
          Revenue and Aftermarket revenue have different intervals for mining
          and non-mining.
        </li>
        <li *ngIf="data.note1">
          All values are from the mentioned time period.
        </li>
      </ul>
    </div>
  </div>
  <app-data-error
    *ngIf="generating"
    [message]="errorMessage"
    [height]="'70vh'"
  ></app-data-error>
</div>
